import { useId } from 'react';

import { Campo } from '../ds/Campo.js';

export interface PropsCampoPublicacao {
  valor: string;
  /** As já usadas, da mais recente para a mais antiga
   *  (`publicacoesUsadas`). Lista vazia é o primeiro uso do app: o campo
   *  continua digitável, só não sugere nada. */
  sugestoes: readonly string[];
  aoMudar: (valor: string) => void;
}

/**
 * "Publicação" com autocompletar das já usadas (spec §8).
 *
 * **Por que `<datalist>` e não uma lista de botões.** O que se quer é não
 * redigitar "A Sentinela — Estudo de outubro" pela vigésima vez, e o
 * `<datalist>` é o autocompletar nativo: o Safari do iPhone o mostra acima do
 * teclado, no tamanho de texto do usuário, e o VoiceOver o anuncia como lista
 * de sugestões sem uma linha de código nossa. Uma lista de botões à parte
 * custaria altura na folha — e altura, nesta folha, é chip saindo da vista —
 * e teria de ser feita de novo em cada tela que sugerir algo.
 *
 * **E ele nunca prende.** O campo continua um campo de texto: nome que não
 * está na lista se digita e pronto. Onde o `<datalist>` não existir, o que
 * sobra é exatamente esse campo de texto — degradação sem quebra.
 */
export function CampoPublicacao({
  valor,
  sugestoes,
  aoMudar,
}: PropsCampoPublicacao) {
  const gerado = useId();
  const idLista = `publicacoes${gerado}`;
  return (
    <>
      <Campo
        rotulo="Publicação"
        placeholder="O que você deixou"
        list={idLista}
        value={valor}
        onChange={(evento) => {
          aoMudar(evento.target.value);
        }}
        // Sugestão do app, não do preenchimento automático do navegador: as
        // duas listas brigando em cima do mesmo campo é o que faz o iPhone
        // esconder uma delas.
        autoComplete="off"
        enterKeyHint="next"
      />
      <datalist id={idLista}>
        {sugestoes.map((sugestao) => (
          <option key={sugestao} value={sugestao} />
        ))}
      </datalist>
    </>
  );
}
